export class BridgePayEventModel {
  type: string;
  data: { status: string; token: string };
}
